module.exports = __webpack_public_path__ + "static/media/housesmart-cta-image.99322be9.svg";